import { useEffect, useRef, useState } from 'react';
/**
 * Эвристика «юзер освоился и пора показать CTA».
 * Триггерится когда выполнены ОБА условия: время на странице >= timeMs И взаимодействий >= interactions.
 * После триггера пульсация активна pulseDuration мс, потом гаснет.
 */
export function useEngagementPulse({ timeMs = 15000, interactions = 3, pulseDuration = 8000, disabled = false, } = {}) {
    const [pulse, setPulse] = useState(false);
    const interactionsRef = useRef(0);
    const timeReachedRef = useRef(false);
    const triggeredRef = useRef(false);
    const stoppedRef = useRef(false);
    const tryTrigger = () => {
        if (triggeredRef.current || stoppedRef.current || disabled)
            return;
        if (!timeReachedRef.current)
            return;
        if (interactionsRef.current < interactions)
            return;
        triggeredRef.current = true;
        setPulse(true);
        if (pulseDuration > 0) {
            setTimeout(() => setPulse(false), pulseDuration);
        }
    };
    // Таймер времени на странице
    useEffect(() => {
        if (disabled)
            return;
        const t = setTimeout(() => {
            timeReachedRef.current = true;
            tryTrigger();
        }, timeMs);
        return () => clearTimeout(t);
    }, [timeMs, disabled]);
    // Сброс пульсации при disabled
    useEffect(() => {
        if (disabled)
            setPulse(false);
    }, [disabled]);
    const notify = () => {
        if (stoppedRef.current || disabled)
            return;
        interactionsRef.current += 1;
        tryTrigger();
    };
    const reset = () => {
        stoppedRef.current = true;
        triggeredRef.current = false;
        setPulse(false);
    };
    return { pulse, notify, reset };
}
